import { Refresh } from 'iconsax-react';

import reminderTemplateApi from '../services/reminder-template-api';
import { Button } from '@src/design-system/button';
import { Spinner } from '@src/design-system/spinner';
import {
  REMINDER_TEMPLATE_STATUS,
  type TReminderTemplate,
} from '@src/shared/types/reminder-template';
import { REMINDER_CHANNELS } from '@src/shared/types/reminder';

const ALLOWED_CHANNELS_FOR_SYNC = [
  REMINDER_CHANNELS.whatsapp,
  REMINDER_CHANNELS.sms,
] as string[];

export const SyncReminderTemplateButton = ({
  id,
  channel,
  status,
}: {
  id: number;
  channel: TReminderTemplate['channel'];
  status: TReminderTemplate['status'];
}) => {
  const { mutate: syncTemplate, isPending } = reminderTemplateApi.useSync();

  const handleSync = (e: React.MouseEvent) => {
    e.stopPropagation();
    syncTemplate({ id });
  };

  if (!ALLOWED_CHANNELS_FOR_SYNC.includes(channel)) return null;
  if (status !== REMINDER_TEMPLATE_STATUS.pending) return null;

  return (
    <Button
      variant='ghost'
      size='iconXs'
      className='text-primary-900'
      onClick={handleSync}
      disabled={false}
      isLoading={isPending}
      loaderFallback={<Spinner />}
    >
      <Refresh
        size={18}
        className={isPending ? 'animate-spin' : ''}
      />
    </Button>
  );
};
